import { render, staticRenderFns } from "./KnowledgeBaseList.vue?vue&type=template&id=87e8ad6a&scoped=true&"
import script from "./KnowledgeBaseList.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseList.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseList.vue?vue&type=style&index=0&id=87e8ad6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e8ad6a",
  null
  
)

export default component.exports